import React from 'react';
import { withRouter } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { Badge, ButtonGroup, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
//import Form from 'react-bootstrap/Form';
//import NewVenue from 'components/AddNewVenue/AddNewVenue';
//import NewVenueV2 from 'components/AddNewVenue/AddNewVenueV2';
import axios from 'axios';

import ReactTooltip from 'react-tooltip';

import { BroadcastChannel } from 'broadcast-channel';

import LeafCard from 'components/Leaves/LeafCard';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import { org_friendly_url, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import '../style.css';
//import Button from "components/Button/Button";
//import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { local_routes } from 'utils/Routes';
//import { NavLink } from 'react-router-dom';
//import { GoogleApiWrapper } from 'google-maps-react';
//let imgTempArr = [];



class RunOfShow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            played_muted: false,
            show_controls_in_player: false,
            //event_admin_flag: false,
            //source_owner: false,
            runofshow_leaves: [],
            event_presentations_array: [],
            loading: true,
            message: '',
            error_message: '',
            global_editing: false,
            global_playing: false,
            currently_playing_leaf_index: null,
            connected: false,
        };

        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
        this.blank_leaf = {
            leaf_type: 'image',
            //leaf_asset_url: '',
            leaf_name: '',
            asset_name: '',
            //loading: false,
            editing: true
        }
        
        this.channel = new BroadcastChannel('event_runofshow_'+this.props.event_info.friendly_url);
        
        this.channel.onmessage = msg => this.handleControlMessage(msg);
        
        this.ack = false;
        
        //this.ack_interval = null;
        this.ack_interval = setInterval(() => {
            this.ack = false;
            this.postChannelMessage({cmd:'ack'});
            //this.postChannelMessage({cmd:'toggle_controls',show_controls:this.state.show_controls_in_player});
            //this.postChannelMessage({cmd:'toggle_mute',mute:this.state.player_muted});
            setTimeout(() => this.handleAck(),1000);
        },2000);
        
        this.leaves_anchor_ref = React.createRef();
        
        this.runofshowplay_window = null;
    }
    
    componentWillUnmount() {
        clearInterval(this.ack_interval);
    }
    
    handleControlMessage = (msg) => {
        console.log("handleControlMessage",msg);
        let cmd_obj = {};
        try {
          cmd_obj = JSON.parse(msg);
        } catch (err) {
          console.error("ERROR parsing JSON",err,msg);
          return;
        }
    
        if (!cmd_obj.cmd) {
          console.error("INVALID cmd",cmd_obj);
          return;
        }
        
        let new_leaf_index = null;
    
        switch (cmd_obj.cmd) {
            case "ack": {
                this.ack = true;
                if (!this.state.connected) {
                    this.setState({
                        connected: true
                    })
                }
                break;
            }
            case "jump_to_leaf": {
                if (cmd_obj.leaf_index !== undefined) {
                  new_leaf_index = cmd_obj.leaf_index;
                }
                this.record_runofshow_command({command_type:cmd_obj.cmd,leaf_index:cmd_obj.leaf_index});
                break;
            }
            /*
            case "next_leaf": {
                if (this.state.currently_playing_leaf_index < (this.state.runofshow_leaves.length - 1)) {
                  new_leaf_index++;  
                }
                break;
            }
            case "prev_leaf": {
                if (this.state.currently_playing_leaf_index > 0) {
                  new_leaf_index--;
                }
                break;
            }
            */
            case "toggle_mute": {
                if (cmd_obj.muted !== undefined) {
                    this.setState({
                        player_muted: cmd_obj.muted
                    })
                }
                break;
            }
        }
        if (new_leaf_index !== null) {
            // disable editing if currently editing
            let tmp_runofshow_leaves = [...this.state.runofshow_leaves];
            tmp_runofshow_leaves.forEach( element => {
                if (element.editing)  {
                    element.editing = false;
                }
            });
            
            this.setState({
                runofshow_leaves: tmp_runofshow_leaves,
                global_playing: true,
                global_editing: false,
                currently_playing_leaf_index: new_leaf_index
            });
        }
    }
    
    componentDidMount = async function () {
        if (!this.props.event_uuid) {
            console.error("BAD! No event_uuid");
            return;
        }
        
        if (!this.props.source_info.entity_type || !this.props.source_info.entity_uuid) {
            console.error("BAD! No source_info",this.props.source_info);
            return;
        }
        
        await this.APICalls();
    }

    APICalls = async function (config = {}) {
        let new_state = {...this.state};

        let api_promises = [];
        
        let params = {
            attributes: ['runofshow_leaves']
        };
        api_promises.push(axios.get(`${apiUrl}events/${this.props.event_info.entity_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control}));
        
        params = {
            attributes: ['entity_uuid','entity_name','image_url','presentation_video_url','status_code'],
            filter_obj: {
                status_code: {
                    eq: 1
                },
                order_integer: {
                    gte: 1
                }
            },
            sort_obj: {
                order_integer: 'asc'
            }
        };
        api_promises.push(axios.get(`${apiUrl}events/${this.props.event_info.entity_uuid}/presentations`, { params, ...myHeaders_Auth_With_Cache_Control}));
        
        let [event_info_response, event_presentations_response] = await Promise.all(api_promises);
        
        if (event_info_response.data.runofshow_leaves) {
            new_state.runofshow_leaves = event_info_response.data.runofshow_leaves;
        }
        //console.log("YO",event_presentations_response.data);
        
        if (event_presentations_response.data) {
            new_state.event_presentations_array = event_presentations_response.data;
        }
        
        // massage asset_name
        new_state.runofshow_leaves.forEach( element => {
            if (element.leaf_asset_url) {
                element.asset_name = element.leaf_asset_url.split('/').pop();
            } else {
                element.asset_name = '';
            }
            element.anchor_ref = React.createRef();
            element.editing = false;
            element.playing = false;
            //element.loading = false;
        })

        if (config.message) {
            new_state.message = config.message;
        } else {
            new_state.message = "";
        }
        if (config.error_message) {
            new_state.error_message = config.error_message;
        } else {
            new_state.error_message = "";
        }
        new_state.loading = false;
        
        this.setState( new_state );
    }

    onSaveRunOfShow = async (runofshow_leaves) => {
        console.log("onSaveRunOfShow",runofshow_leaves);
        //this.setState({
            //loading: true
        //});
        
        // we only want leaf_* attributes in the API/DB
        let tmp_runofshow_leaves = runofshow_leaves.map( leaf => ({...leaf}));
        tmp_runofshow_leaves.forEach( element => {
            for (let leaf_attribute of Object.keys(element)) {
                if (!leaf_attribute.startsWith('leaf_')) {
                    delete element[leaf_attribute];
                }
                if (element[leaf_attribute] === "") {
                    delete element[leaf_attribute];
                }
            }
        });

        /*
        let patch_obj = {};        
        runofshow_leaves.forEach( element => {
            for (let leaf_attribute of Object.keys(element)) {
                if (leaf_attribute.startsWith('leaf_')) {
                    patch_obj.leaf_attribute
                }
            }
        */
        await axios.patch(`${apiUrl}events/${this.props.event_info.entity_uuid}`, {runofshow_leaves: tmp_runofshow_leaves});
        
        //this.setState({
        //    loading: false
        //});
    }
    
    onFinish = () => {
        let next_page = `${this.workspace_base_url}${local_routes.myevents}`;
        if (this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }
    
    onSaveLeaf = async (leaf_index,leaf_info) => {
        console.log("onSaveLeaf 2",leaf_index,leaf_info);
        let tmp_runofshow_leaves = [...this.state.runofshow_leaves];
        //console.log("onSaveLeaf 2.1",this.state.runofshow_leaves,tmp_runofshow_leaves);
        
        /*
        //let tmp_runofshow_leaves = this.state.runofshow_leaves.map( leaf => ({...leaf}));
        let tmp_leaf = {...this.state.runofshow_leaves[leaf_index]};
        tmp_leaf = {
            ...tmp_leaf,
            ...leaf_info,
            editing: false
        }
        console.log("onSaveLeaf 2.1",this.state.runofshow_leaves[leaf_index],tmp_leaf);
        */
        tmp_runofshow_leaves[leaf_index] = {
            ...tmp_runofshow_leaves[leaf_index],
            ...leaf_info,
            editing: false
        };
        //tmp_runofshow_leaves[leaf_index].editing = false;
        //tmp_runofshow_leaves[leaf_index].loading = false;
        
        this.onSaveRunOfShow(tmp_runofshow_leaves);
        
        //console.log("onSaveLeaf 2.2",tmp_runofshow_leaves);
        
        this.setState({
            runofshow_leaves: tmp_runofshow_leaves,
            global_editing: false
        },() => ReactTooltip.rebuild())
    }

    onAddLeaf = () => {
        console.log("onAddLeaf");
        this.setState({
            runofshow_leaves: [
                ...this.state.runofshow_leaves,
                {...this.blank_leaf,anchor_ref: React.createRef()}
            ],
            global_editing: true
        },() => this.handleScrollTo(this.state.runofshow_leaves.length-1));
        
    }
    
    onRemoveLeaf = async (leaf_index) => {
        console.log("onRemoveLeaf",leaf_index);
        let tmp_runofshow_leaves = [...this.state.runofshow_leaves];
        tmp_runofshow_leaves.splice(leaf_index,1);

        if (this.state.runofshow_leaves[leaf_index].leaf_name) {
            // existing leaf - call API to remove leaf
            this.onSaveRunOfShow(tmp_runofshow_leaves);
        }

        // if we removed one in the middle, re-mount leaves
        if (leaf_index !== tmp_runofshow_leaves.length) {
            this.setState({
                runofshow_leaves: [],
                global_editing: false,
                //currently_playing_leaf_index: null
            },() => {
                this.setState({
                    runofshow_leaves: tmp_runofshow_leaves,
                    currently_playing_leaf_index: this.state.currently_playing_leaf_index > leaf_index ? this.state.currently_playing_leaf_index-1 : this.state.currently_playing_leaf_index
                },() => ReactTooltip.rebuild());
            });
        } else {
            this.setState({
                runofshow_leaves: tmp_runofshow_leaves,
                global_editing: false,
                currently_playing_leaf_index: this.state.currently_playing_leaf_index ? tmp_runofshow_leaves.length-1 : null
            },() => ReactTooltip.rebuild());
        }
    }

    onMoveLeaf = async (leaf_index,to_leaf_index) => {
        console.log("onMoveLeaf",leaf_index,to_leaf_index);
        let tmp_runofshow_leaves = [...this.state.runofshow_leaves];
        tmp_runofshow_leaves.splice(leaf_index,1);
        tmp_runofshow_leaves.splice(to_leaf_index,0,this.state.runofshow_leaves[leaf_index]);

        // re-mount leaves
        this.setState({
            runofshow_leaves: [],
            global_editing: false
        },() => {
            this.setState({runofshow_leaves: tmp_runofshow_leaves}, () => ReactTooltip.rebuild());
        });
        
        // save re-ordered leaves
        this.onSaveRunOfShow(tmp_runofshow_leaves);
    }

    handlePlayVideo = (leaf_index) => {
        if (this.runofshow_play_window) {
            this.runofshow_play_window.focus();
        }
        let channel_msg = {
            cmd: 'play_video'
        }
        this.postChannelMessage(channel_msg);
    }
    handlePauseVideo = (leaf_index) => {
        if (this.runofshow_play_window) {
            this.runofshow_play_window.focus();
        }
        let channel_msg = {
            cmd: 'pause_video'
        }
        this.postChannelMessage(channel_msg);
    }
    
    handleAck = () => {
        if (!this.ack) {
            console.error("LOST CHANNEL");
            clearInterval(this.ack_interval);
            //this.ack_interval = null;
            
            if (this.state.global_playing && this.state.connected) {
                this.record_runofshow_command({command_type:'stop',leaf_index:this.state.currently_playing_leaf_index});
            }
            
            this.runofshow_play_window = null;
            this.setState({
                global_playing: false,
                currently_playing_leaf_index: null,
                connected: false
            });
            
        }
    }
    
    postChannelMessage = (msg_obj) => {
        this.channel.postMessage(JSON.stringify(msg_obj));
        
        if (msg_obj.cmd === 'jump_to_leaf') {
            // record command
            this.record_runofshow_command({command_type:msg_obj.cmd,leaf_index:msg_obj.leaf_index});
        }
    }

    onChangeShowControls = (event) => {
        this.postChannelMessage({cmd:'toggle_controls',show_controls:!this.state.show_controls_in_player});
        if (this.runofshow_play_window) {
            this.runofshow_play_window.focus();
        }
        this.setState({show_controls_in_player:!this.state.show_controls_in_player});
    }
    onChangePlayerMute = (event) => {
        
        this.postChannelMessage({cmd:'toggle_mute',muted:!this.state.player_muted});

        if (this.runofshow_play_window) {
            this.runofshow_play_window.focus();
        }
        this.setState({player_muted:!this.state.player_muted});
    }

    handleScrollTo = (leaf_index,event) => {
        console.log("handleScrollTo",leaf_index,event);
        
        if (leaf_index < 0 || leaf_index >= this.state.runofshow_leaves.length) {
            // do nothing
            return;
        }
        
        if (this.state.global_playing) {
            
            if (event) {
                //event.preventDefault();
                //event.stopPropagation();
                //window.blur();
            }
            
            if (this.runofshow_play_window) {
                this.runofshow_play_window.focus();
            }
            
            let channel_msg = {
                cmd: 'jump_to_leaf',
                leaf_index
            }
            this.postChannelMessage(channel_msg);

            this.setState({
                currently_playing_leaf_index: leaf_index,
            }, () => ReactTooltip.rebuild());
            
            if (leaf_index === 0) {
                // so we keep the control bar in the right spot
                leaf_index = 1;
            }
            
            
            const el = this.state.runofshow_leaves[leaf_index].anchor_ref.current ? this.state.runofshow_leaves[leaf_index].anchor_ref.current : this.state.runofshow_leaves[leaf_index].anchor_ref;
        
            
            el.scrollIntoView({
                //behavior: 'smooth',
                block: 'center'
            });
            
            
            //return false;
        
        } else {
            const el = this.state.runofshow_leaves[leaf_index].anchor_ref.current ? this.state.runofshow_leaves[leaf_index].anchor_ref.current : this.state.runofshow_leaves[leaf_index].anchor_ref;
            
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
          
        }
        /*
        const el = this.state.runofshow_leaves[leaf_index].anchor_ref.current ? this.state.runofshow_leaves[leaf_index].anchor_ref.current : this.state.runofshow_leaves[leaf_index].anchor_ref;
        
        el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        */
    }
    
    onEditing = (leaf_index,editing) => {
        console.log("onEditing",leaf_index,editing);
        let tmp_runofshow_leaves = [...this.state.runofshow_leaves];
        tmp_runofshow_leaves[leaf_index].editing = editing;
        this.setState({
            runofshow_leaves: tmp_runofshow_leaves,
            global_editing: editing
        });
    }
    
    record_runofshow_command = async (config) => {
        console.log("record_runofshow_command",config,this.state.runofshow_leaves);
        let api_promises = [];
        let post_obj = [
            {
                command_type: config.command_type,
                command_time: Math.floor(new Date().getTime() / 1000),
                leaf_index: config.leaf_index
            }    
        ];
        api_promises.push(axios.post(`${apiUrl}events/${this.props.event_info.entity_uuid}/runofshow_play_command_log`,post_obj));

        if (config.command_type === 'jump_to_leaf' || config.command_type === 'start') {
            let xref_attribute = '';
            if (this.state.runofshow_leaves[config.leaf_index].leaf_type === 'presentation_cover') {
                xref_attribute = 'runofshow_presentation_cover_show_time';
            }
            if (this.state.runofshow_leaves[config.leaf_index].leaf_type === 'presentation_video') {
                xref_attribute = 'runofshow_presentation_video_show_time';
            }
            if (xref_attribute) {
                let patch_obj = {
                    presentations: [
                        {
                            entity_uuid: this.state.runofshow_leaves[config.leaf_index].leaf_presentation_uuid,
                            xref_data: {
                                [xref_attribute]: Math.floor(new Date().getTime() / 1000)
                            }
                        }    
                    ]
                }
                api_promises.push(axios.patch(`${apiUrl}events/${this.props.event_info.entity_uuid}`,patch_obj));
            }
        }

        await Promise.all(api_promises);

    }

    onRunOfShowPlay = () => {
        this.leaves_anchor_ref.current.scrollIntoView({
            //behavior: 'smooth',
            block: 'start'
        });
        
        if (this.state.connected && this.runofshow_play_window) {
            this.runofshow_play_window.focus();
            this.onResume();
            return;
        }
        
        clearInterval(this.ack_interval);
        
        // figure out a nice 16:9 new window that fits below the control bar
        //var offsets = this.leaves_anchor_ref.current.getBoundingClientRect();
        //var top = offsets.top;
        //let top_magic = top + window.pageYOffset - this.leaves_anchor_ref.current.ownerDocument.documentElement.clientTop;
        //var left = offsets.left;
        let myscreentop = window.outerHeight - window.innerHeight;
        let myscreenleft = window.outerWidth - window.innerWidth;
        
        //let screen_width = window.screen.width * 0.8;
        //let screen_left = window.screen.width * 0.1;
        
        let screen_width = window.outerWidth;
        let screen_height = window.innerHeight - (myscreentop * 0.66667) - 90;
        
        //let screen_left = myscreenleft;
        //let screen_top = (myscreentop * (myscreentop * 0.6667)) + 50;
        //let screen_top = myscreentop * 3;
        let screen_top = (myscreentop * 1.3333) + 85;
        
        // adjust width/height to get to 16:9
        
        if (screen_width / screen_height >= 1.78) {
            // too wide
            while (screen_width / screen_height > 1.78) {
                // shrink width by 5px increments until we are 16:9
                screen_width -= 5;
            }
        } else {
            // too tall
            while (screen_width / screen_height < 1.78) {
                // shrink height by 5px increments until we are 16:9
                screen_height -= 5;
            }
        }
        
        if (this.state.show_controls_in_player) {
            //screen_width += 55;
            screen_width -= 55;
            //screen_height += 31;
            //screen_top -= 19;
        }
        
        let screen_left = (window.screen.width - screen_width) / 2;
        
        console.log("MAGIC",screen_top,screen_left,screen_height,screen_width);
        this.runofshow_play_window = window.open('about:blank', 'PechaKucha Event Play', 'top='+screen_top+',left='+screen_left+',height='+screen_height+',width='+screen_width+',scrollbars=0,toolbar=0,location=0,status=0,menubar=0');
        //let newWindow = window.open('about:blank', '_blank', 'toolbar=0,location=0,menubar=0');
        
        this.record_runofshow_command({command_type:'start',leaf_index:0});
        
        this.runofshow_play_window.location = this.workspace_base_url+'/runofshowplay/'+this.props.event_info.friendly_url+'/'+(this.state.currently_playing_leaf_index+1);
        //const channel = new BroadcastChannel('event_runofshow_'+this.props.event_info.friendly_url);
        
        // reset ack interval to give new window time to load
        setTimeout(() => {
            this.ack_interval = setInterval(() => {
                this.ack = false;
                this.postChannelMessage({cmd:'ack'});
                setTimeout(() => this.handleAck(),1000);
            },2000);
            this.postChannelMessage({cmd:'toggle_controls',show_controls:this.state.show_controls_in_player});
            this.postChannelMessage({cmd:'toggle_mute',muted:this.state.player_muted});
        },2000);
        
        /*
        if (!this.ack_interval) {
            this.ack_interval = setInterval(() => {
                this.ack = false;
                this.postChannelMessage({cmd:'ack'});
                setTimeout(() => this.handleAck(),1000);
            },2000);
        }
        */
        
        /*
        let channel_msg = {
            cmd: 'jump_to_leaf',
            leaf_index: this.state.currently_playing_leaf_index
        }
        this.channel.postMessage(JSON.stringify(channel_msg));
        */
        //channel.postMessage('I am not alone');
    }
    
    onResume = () => {
        this.postChannelMessage({cmd:'refresh_leaves'});
    }
    
    onChangePlaying = () => {
        console.log("onChangePlaying");
        if (this.state.global_playing) {
            // necessary for mac
            window.focus();
        }
        //this.onRunOfShowPlay();
        this.setState({
            global_playing: !this.state.global_playing,
            currently_playing_leaf_index: !this.state.currently_playing_leaf_index ? 0 : this.state.currently_playing_leaf_index
        },() => { ReactTooltip.rebuild(); this.state.global_playing && this.onRunOfShowPlay() })
        
    }
    
    onEventWizard = () => {
        console.log("onEventWizard");
        this.setState({
            loading: true
        });
        let tmp_runofshow_leaves = [];

        // build event intro slide
        let leaf_name = `Event Intro`;
        
        let leaf_info = {
            leaf_name,
            leaf_type: 'event_cover',
            leaf_event_cover_options: {
              smart_overlay: true
            },
            anchor_ref: React.createRef(),
            editing: false
        };
        
        tmp_runofshow_leaves.push(leaf_info);

        this.state.event_presentations_array.forEach( (element,index) => {
            let leaf_name = `PK #${index+1} (Cover): ${element.entity_name}`;
            
            let leaf_info = {
               leaf_name,
               leaf_type: 'presentation_cover',
               leaf_presentation_uuid: element.entity_uuid,
               leaf_presentation_cover_options: {
                   smart_overlay: true
               },
               anchor_ref: React.createRef(),
               editing: false
            };
            tmp_runofshow_leaves.push(leaf_info);
            
            leaf_name = `PK #${index+1} (Video): ${element.entity_name}`;
            
            leaf_info = {
               leaf_name,
               leaf_type: 'presentation_video',
               leaf_presentation_uuid: element.entity_uuid,
               anchor_ref: React.createRef(),
               editing: false
            };
            tmp_runofshow_leaves.push(leaf_info);
        });
        this.onSaveRunOfShow(tmp_runofshow_leaves);
        this.setState({
            loading: false,
            runofshow_leaves: tmp_runofshow_leaves
        }, () => ReactTooltip.rebuild());
    }
    
    finish = () => {
        let next_page = `${this.workspace_base_url}${local_routes.myevents}`;
        if (this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="spinner-pos">
                    <FullPageSpinner />
                </div>
            );
        }

        return (
            <div className="eventCreation">
                <Container>
                    {this.state.runofshow_leaves.length > 0 &&
                    <Row ref={this.leaves_anchor_ref} style={{ marginBottom: "5px" }} className="justify-content-center sticky-top">
                        {/* <Col xs={0}></Col> */}
                        <Col xs={8}>
                            <ButtonToolbar>
                                <ButtonGroup style={{ flexWrap: "wrap" }}>
                                    { this.state.runofshow_leaves.map( (leaf_info, index ) => (
                                        <Button
                                            onContextMenu={(e)=>  {e.preventDefault();}}
                                            data-tip={leaf_info.leaf_name}
                                            style={this.state.runofshow_leaves.length > 10 ? { maxWidth: "30px" } : { maxWidth: "40px" }}
                                            size={this.state.runofshow_leaves.length > 10 ? 'sm' : 'md'}
                                            disabled={this.state.global_editing && !leaf_info.editing}
                                            key={index}
                                            variant={leaf_info.editing ? "info" : this.state.currently_playing_leaf_index === index ? "pkprimary" : "secondary"}
                                            //onClick={(event) => this.handleScrollTo(index,event)}
                                            onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handleScrollTo(index,event)}}
                                        >
                                            {index+1}
                                        </Button>
                                    ))}
                                </ButtonGroup>
                                { this.state.global_playing &&
                                    <React.Fragment>
                                    <ButtonGroup style={{ marginLeft: "10px", flexWrap: "wrap" }}>
                                        <Button
                                            onContextMenu={(e)=>  {e.preventDefault();}}
                                            disabled={this.state.currently_playing_leaf_index === 0}
                                            data-tip={'Go Back One Slide'}
                                            //style={this.state.runofshow_leaves.length > 10 ? { maxWidth: "30px" } : { maxWidth: "40px" }}
                                            size={this.state.runofshow_leaves.length > 10 ? 'sm' : 'md'}
                                            //disabled={this.state.global_editing}
                                            //key={index}
                                            variant={"pkprimary"}
                                            //onClick={(event) => this.handleScrollTo(index,event)}
                                            onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handleScrollTo(this.state.currently_playing_leaf_index-1,event)}}
                                        >
                                            <i className="fa fa-step-backward" aria-hidden="true"></i>
                                        </Button>
                                        <Button
                                            onContextMenu={(e)=>  {e.preventDefault();}}
                                            disabled={this.state.currently_playing_leaf_index === this.state.runofshow_leaves.length-1}
                                            data-tip={'Go Forward One Slide'}
                                            //style={this.state.runofshow_leaves.length > 10 ? { maxWidth: "30px" } : { maxWidth: "40px" }}
                                            size={this.state.runofshow_leaves.length > 10 ? 'sm' : 'md'}
                                            //disabled={this.state.global_editing}
                                            //key={index}
                                            variant={"pkprimary"}
                                            //onClick={(event) => this.handleScrollTo(index,event)}
                                            onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handleScrollTo(this.state.currently_playing_leaf_index+1,event)}}
                                        >
                                            <i className="fa fa-step-forward" aria-hidden="true"></i>
                                        </Button>
                                    </ButtonGroup>
                                    </React.Fragment>
                                }
                            </ButtonToolbar>
                        </Col>
                        <Col xs={4}>
                            <Row>

                            <ToggleButtonGroup
                              type="radio"
                              name="playing"
                              value={this.state.global_playing}
                              onMouseDown={this.onChangePlaying}
                              //onChange={this.onChangePlaying}
                            >
                                <ToggleButton
                                    onContextMenu={(e)=>  {e.preventDefault();}}
                                    disabled={this.state.global_editing}
                                    variant={"pkprimary"}
                                    value={false}
                                >
                                    {this.state.global_playing ? 'Edit' : 'Editing'}
                                </ToggleButton>
                                <ToggleButton
                                    onContextMenu={(e)=>  {e.preventDefault();}}
                                    disabled={this.state.global_editing}
                                    variant={"pkprimary"}
                                    value={true}
                                >
                                    {this.state.global_playing ? 'Playing' : 'Play'}
                                </ToggleButton>
                            </ToggleButtonGroup>
                            { this.state.connected &&
                                <Badge style={{ marginLeft: "5px" }} >Connected</Badge>
                            }
                            { (this.state.connected && this.state.global_playing && this.state.runofshow_leaves.length > 0 && this.state.runofshow_leaves[this.state.currently_playing_leaf_index].leaf_type.endsWith("video")) &&
                                <React.Fragment>
                                <Button
                                    onContextMenu={(e)=>  {e.preventDefault();}}
                                    data-tip={'Play Video'}
                                    style={{ marginLeft: "5px" }}
                                    size="sm"
                                    variant="pkprimary"
                                    //onClick={this.handlePlayVideo}
                                    onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handlePlayVideo(event)}}
                                >
                                    <i className="fa fa-play" aria-hidden="true"></i>
                                </Button>
                                <Button
                                    onContextMenu={(e)=>  {e.preventDefault();}}
                                    data-tip={'Pause Video'}
                                    size="sm"
                                    variant="pkprimary"
                                    //onClick={this.handlePauseVideo}
                                    onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handlePauseVideo(event)}}
                                >
                                    <i className="fa fa-pause" aria-hidden="true"></i>
                                </Button>
                                </React.Fragment>
                            }
                            </Row>
                            <Row style={{ marginTop: "5px" }}>
                            
                                <ToggleButtonGroup
                                    onContextMenu={(e)=> {e.preventDefault();}}
                                    //size="sm"
                                    style={{marginRight: "10px"}}
                                    type="checkbox"
                                    //onChange={() => {this.setState({show_controls_in_player:!this.state.show_controls_in_player})}}
                                    onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.onChangeShowControls(event)}}
                                >
                                    <ToggleButton
                                        size="sm"
                                        //type="checkbox"
                                        variant="secondary"
                                        checked={this.state.show_controls_in_player}
                                        value="1"
                                        //onChange={(e) => setChecked(e.currentTarget.checked)}
                                    >
                                      {this.state.show_controls_in_player ? 'Hide Controls in Player' : 'Show Controls in Player'}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                <ToggleButtonGroup
                                    onContextMenu={(e)=> {e.preventDefault();}}
                                    //size="sm"
                                    //style={{marginRight: "10px"}}
                                    type="checkbox"
                                    //onChange={() => {this.setState({show_controls_in_player:!this.state.show_controls_in_player})}}
                                    onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.onChangePlayerMute(event)}}
                                >
                                    <ToggleButton
                                        size="sm"
                                        //type="checkbox"
                                        variant="secondary"
                                        checked={this.state.player_muted}
                                        value="1"
                                        //onChange={(e) => setChecked(e.currentTarget.checked)}
                                    >
                                      {this.state.player_muted ? 'Unmute Player Video' : 'Mute Player Video'}
                                    </ToggleButton>
                                </ToggleButtonGroup>                            

                            
                            </Row>
                        </Col>
                    </Row>
                    }
                    { this.state.runofshow_leaves.map( (leaf_info, index ) => (
                        <div key={index} ref={leaf_info.anchor_ref}>
                        <LeafCard
                            //ref={leaf_info.anchor_ref}
                            //key={index}
                            leaf_info={{...leaf_info,leaf_index:index}}
                            onSaveLeaf={this.onSaveLeaf}
                            global_editing={this.state.global_editing}
                            global_playing={this.state.global_playing}
                            onEditing={this.onEditing}
                            onRemoveLeaf={this.onRemoveLeaf}
                            onMoveLeaf={this.onMoveLeaf}
                            event_uuid={this.props.event_info.entity_uuid}
                            event_presentations_array={this.state.event_presentations_array}
                            event_info={this.props.event_info}
                            leaf_count={this.state.runofshow_leaves.length}
                        />
                        </div>
                    ))}
                    <Row style={{ marginTop: "5px", marginBottom: "500px" }} className="justify-content-center">
                        <Col xs="auto">
                            { this.state.runofshow_leaves.length === 0 &&
                                <Button
                                    style={{ marginRight: "2px" }}
                                    variant="pkprimary"
                                    onClick={this.onEventWizard}
                                >
                                    Event Wizard
                                </Button>
                            }
                            <Button
                                disabled={this.state.global_editing || this.state.global_playing}
                                onClick={this.onAddLeaf}
                                variant="pkprimary"
                            >
                                Add New Leaf
                            </Button>
                        </Col>
                    </Row>
                    {/*
                    <Row style={{ marginTop: "10px" }} className="justify-content-center">
                        <Col xs="auto">
                            <ButtonToolbar data-tip="Jump to a leaf">
                                <ButtonGroup>
                                    { this.state.runofshow_leaves.map( (leaf_info, index ) => (
                                        <Button disabled={this.state.global_editing && !leaf_info.editing} key={index} variant={leaf_info.editing ? "info" : "secondary"} onClick={() => this.handleScrollTo(index)}>{index+1}</Button>
                                    ))}
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                    */}
                </Container>
                <div className="form-group btn-venueposition">
                    <React.Fragment>
                        <Button
                            size="sm"
                            onClick={this.finish}
                            variant="secondary"
                        >
                            Finish
                        </Button>
                    </React.Fragment>
                </div>
                <ReactTooltip/>
            </div>
        );
    }
}

export default withRouter(RunOfShow);